export enum TalentLinkAutomationEnum {
  NO_AUTOMATION = "noAutomation",
  AUTOMATION_ON_APPLICATION_CREATION = "automationOnApplicationCreation",
  AUTOMATION_ON_APPLICATION_AI_EVALUATION = "automationOnApplicationAiEvaluation",
} 